<template>
  <form action="javascript:;" @submit="submit()">
    <div class="form-group row mobile-grid">
      <div class="col">
        <label for="title">{{ $t("improvements.improvement.title") }}</label>
        <input
            type="text"
            id="title"
            autofocus
            v-model="improvement.title"
            name="title"
            v-validate="'required'"
            class="form-control"
        />
        <required-notice
            v-if="errors.first('title')"
            :notice="errors.first('title')"
        />
      </div>

      <div class="col" v-if="getMyDepartments && getMyDepartments.length">
        <label for="department">Department</label>
        <select
            v-validate="'required'"
            v-model="improvement.department"
            name="department"
            class="form-control"
            id="department"
        >
          <option
              :value="department"
              :key="index + 1"
              v-for="(department, index) in getMyDepartments"
          >
            {{ department }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mb-5">
    <div class="col-lg-8 col-sm-12">
    <div class="form-group">
      <label for="body">{{ $t("improvements.improvement.body") }}</label>
      <textarea
          v-validate="'required|min:10'"
          class="form-control"
          name="body"
          id="body"
          cols="30"
          v-model="improvement.body"
          rows="10"
      ></textarea>
      <required-notice
          v-if="errors.first('body')"
          :notice="errors.first('body')"
      />
    </div>
    </div>
      <div class="col-lg-4 col-sm-12">
        <template>
          <div id="improvements-upload-wrapper" class="  align-items-center justify-content-center">
            <div class="upload">
              <!--TODO : Moet nog in verschillende talen-->
              <!--          <h3 class="title">Upload </h3>-->
              <label for="">{{ $t('improvements.uploadImage') }}


              </label>
              <VueFileAgent
                  id="file-upload"
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="true"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/jpg,image/jpeg,image/png'"
                  :maxSize="allowedFileSize"
                  :maxFiles="5"
                  :helpText="$t('dragAndDropContainer.helpText')"
                  :errorText="{
            type: $t('admin.floorPlan.fileUpload.fileNotAllowed'),
            size: $t('dragAndDropContainer.errorText.size', { allowedFileSize }),
          }"
                  @select="handleFileChange($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="improvement.file"
              >
                <template v-slot:file-preview>
                </template>
                <template v-slot:file-preview-new>
                  <div class="d-flex align-items-center justify-content-center upload-info" key="new">
                    <div class="row">
                      <div class="col-12">
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" class="upload-icon"
                             xmlns="http://www.w3.org/2000/svg">
                          <path
                              d="M34 20H33.25C33.25 20.4142 33.5858 20.75 34 20.75V20ZM37.6245 34.3508C37.2659 34.5582 37.1434 35.017 37.3508 35.3755C37.5582 35.7341 38.017 35.8566 38.3755 35.6492L37.6245 34.3508ZM16.2478 21.105C16.6417 21.2333 17.0649 21.018 17.1932 20.6242C17.3215 20.2303 17.1063 19.8071 16.7124 19.6788L16.2478 21.105ZM9.62446 35.6492C9.983 35.8566 10.4418 35.7341 10.6492 35.3755C10.8566 35.017 10.7341 34.5582 10.3755 34.3508L9.62446 35.6492ZM24 24L24.5303 23.4697C24.2374 23.1768 23.7626 23.1768 23.4697 23.4697L24 24ZM23.25 42C23.25 42.4142 23.5858 42.75 24 42.75C24.4142 42.75 24.75 42.4142 24.75 42H23.25ZM29.4697 30.5303C29.7626 30.8232 30.2374 30.8232 30.5303 30.5303C30.8232 30.2374 30.8232 29.7626 30.5303 29.4697L29.4697 30.5303ZM17.4697 29.4697C17.1768 29.7626 17.1768 30.2374 17.4697 30.5303C17.7626 30.8232 18.2374 30.8232 18.5303 30.5303L17.4697 29.4697ZM14.75 18C14.75 12.8914 18.8914 8.75 24 8.75V7.25C18.0629 7.25 13.25 12.0629 13.25 18H14.75ZM24 8.75C29.1086 8.75 33.25 12.8914 33.25 18H34.75C34.75 12.0629 29.9371 7.25 24 7.25V8.75ZM33.25 18V20H34.75V18H33.25ZM13.25 18V20H14.75V18H13.25ZM34 20.75C38.0041 20.75 41.25 23.9959 41.25 28H42.75C42.75 23.1675 38.8325 19.25 34 19.25V20.75ZM41.25 28C41.25 30.6899 39.787 33.0998 37.6245 34.3508L38.3755 35.6492C40.9954 34.1337 42.75 31.2324 42.75 28H41.25ZM6.75 28C6.75 23.9959 9.99594 20.75 14 20.75V19.25C9.16751 19.25 5.25 23.1675 5.25 28H6.75ZM14 20.75C14.7858 20.75 15.5411 20.8748 16.2478 21.105L16.7124 19.6788C15.8575 19.4003 14.9456 19.25 14 19.25V20.75ZM10.3755 34.3508C8.21301 33.0998 6.75 30.6899 6.75 28H5.25C5.25 31.2324 7.00458 34.1337 9.62446 35.6492L10.3755 34.3508ZM23.25 24V42H24.75V24H23.25ZM30.5303 29.4697L24.5303 23.4697L23.4697 24.5303L29.4697 30.5303L30.5303 29.4697ZM23.4697 23.4697L17.4697 29.4697L18.5303 30.5303L24.5303 24.5303L23.4697 23.4697Z"
                              fill="#4F575E"/>
                        </svg>
                      </div>
                      <div class="col-12 mt-3">
                        <p class="">Drag & drop your image here</p>
                      </div>
                    </div>
                  </div>
                </template>
              </VueFileAgent>
            </div>
          </div>
        </template>
    </div>


    </div>
    <div class="form-group">
      <label for="title"
      >{{ $t("improvements.improvement.employeeName") }}
        <small>{{
            $t("improvements.improvement.employeeNameOption")
          }}</small></label
      >
      <input
          type="text"
          id="employeeName"
          v-model="improvement.employeeName"
          name="employeeName"
          v-validate="'min:3'"
          class="form-control"
      />

      <required-notice
          v-if="errors.first('employeeName')"
          :notice="errors.first('employeeName')"
      />
    </div>

    <!-- Hier is de user die is toegewezen aan de improvement -->
    <!-- <div class="form-group">
      <label for="title"
        >{{ $t("improvements.improvement.employeeNameAssigned") }}
      </label>
      <select
        id="assignedTo"
        @change="setSelected($event)"
        class="form-control"
      >
        <option disabled selected value="">Assign a person to this improvement</option>
        <option v-for="user in allUsers" :key="user.index" :value="user.uid">
          {{ user.displayName }}
        </option>
      </select>
    </div> -->

    <label for="title"
    >{{ $t("improvements.improvement.employeeNameAssigned") }}
    </label>
    <div class="input-group mb-3">
      <select
          name="assignedTo"
          id="assignedTo"
          @change="setSelected($event)"
          class="form-control"
      >
        <option disabled selected value="false">
          {{ $t("improvements.improvement.assignPerson") }}
        </option>
        <option v-for="user in allUsers" :key="user.index" :value="user.uid">
          {{ user.displayName }}
        </option>
      </select>
      <div class="input-group-append">
        <button
            @click="removeSelected()"
            class="btn btn-outline-secondary"
            type="button"
        >
          <i class="fal fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Prefilled email, als iemand wordt toegewezen -->
    <div v-show="improvement.assignedUser.uid" class="form-group">
      <label for="title"
      >{{ $t("improvements.improvement.employeeEmailAssigned") }}
      </label>
      <input
          type="text"
          id="employeeEmail"
          v-model="improvement.assignedUser.email"
          name="employeeEmail"
          class="form-control"
          v-validate="'email'"
      />
    </div>

    <div class="form-group text-right">
      <button class="btn btn-success" type="submit">{{ $t("ui.save") }}</button>
    </div>
  </form>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "ImprovementForm",
  mixins: [],
  components: {},
  data() {
    return {
      allUsers: [],
      improvement: {
        title: "",
        body: "",
        department: null,
        employeeName: "",
        assignedUser: {},
        file: [],
      },
      allowedFileSize: "20MB"
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),

    ...mapGetters("jobs", ["getJobs", "getJob"]),
    ...mapGetters("userData", ["getMyDepartments"]),
    ...mapGetters("users", ["getMe", "getClaims"]),
  },
  methods: {
    setSelected(event) {
      let user = _.find(this.allUsers, (user) => {
        return user.uid == event.target.value;
      });
      this.improvement.assignedUser = {
        name: user.displayName,
        email: user.email,
        uid: user.uid,
      };
    },
    removeSelected() {
      this.improvement.assignedUser = {};
    },
    warningPopUp() {
      return this.$swal({
        icon: "warning",
        title: this.$t("ui.invalidForm"),
        text: this.$t("ui.invalidFormText"),
      });
    },
    submit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return this.warningPopUp();
        } else {
          return this.saveImprovement();
        }
      });
    },
    async saveImprovement() {
      let files = this.improvement.file
    let improvementData = _.omit(this.improvement,['file'])
      let improvement = {
        ...improvementData,
        userId: this.getMe.id,
        likes: [this.getMe.id],
        userName: this.getMe.displayName,
        companyId: this.getClaims.companyId,
        jobId: this.$route.query.jobId ? this.$route.query.jobId : null,
        downTimeId: this.$route.query.downTimeId
            ? this.$route.query.downTimeId
            : null,
        status: "pending",
      };
    this.$store.commit('setLoading',true)
      let docId = await this.$store.dispatch("improvements/set", improvement);
      try {
          for (let i = 0; i < files.length; i++) {
         // file[i]
            let file = files[i]
          //   console.log(file)
            const storageRef = this.$FBClient.storage().ref("improvements/" + this.getClaims.companyId + "/" + docId + "/" + file.file.name);
             await storageRef
                .put(file.file)
                .then(function () {
                  console.log("Uploaded succesfully");
                })
                .catch((error) => {
                  console.log(error.message);
                });
          }

      } catch (e) {
        throw e
      }
      this.$store.commit('setLoading',false)
      this.$router.push("/improvements/" + docId);

      this.swalToastSuccess(this.$t("ui.saved"));
    },


    async handleFileChange(event) {

      for (let i = 0; i < event.length; i++) {
        let file = event[i].file

        let fileExtension = file.ext
        if (fileExtension == 'pdf') {
          await this.$swal({
            icon: 'error',
            width: '50%',
            text: this.$root.$t('admin.floorPlan.fileUpload.pdfNotAllowed')
          })
        } else {
          if (file.file) {
            this.improvement.file.push(file)
          }
        }
      }
    },
    onBeforeDelete(fileRecord) {
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
    },
    fileDeleted(fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord);
      this.fileRecordsForUpload.splice(i, 1);
    }
  },
  async created() {
     this.improvement.employeeName = this.getMe.displayName;

    this.$store.commit("setLoading", true);
    this.$FUNCTIONS
        .Users("getAllUsers")
        .then((res) => {

          this.allUsers = _.sortBy(res.data, ['displayName'], ['desc'])
          this.$store.commit("setLoading", false);
        })
        .catch((e) => {

          this.$store.commit("setLoading", false);
        });

    if (this.$route.query.jobId) {
      let job = await this.$store.dispatch(
          "jobs/fetchById",
          this.$route.query.jobId
      );

      this.improvement.department = job.department ? job.department : null;
      if (job.orderNumber) {
        this.improvement.title = job.orderNumber + " ";
      } else {
        this.improvement.title = job.uid + " ";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/mobile/mobileSettings";

#file-upload {
width:100%;
  min-width:300px;
  max-width:100%;
}
#improvements-upload-wrapper {

}
@media only screen and (max-device-width: $maxMobileWidth) {
  .mobile-grid {
    display: grid !important;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    grid-column-gap: 0px;
    grid-row-gap: 12px;
  }
}
</style>
